import { RootState } from './types';
import { authReducer } from './auth/reducer';
import { claimDetailsReducer } from './claim-details/reducer';
import { claimsReducer } from './claim/reducer';
import { combineReducers, Reducer } from 'redux';
import { createVisitReducer } from './create-visit/reducer';
import { dashboardReducer } from './dashboard/reducer';
import { feeScheduleReducer } from './fee-schedule/reducer';
import { marketsReducer } from './markets/reducer';
import { messageReducer } from './message/reducer';
import { onSiteManagerReducer } from './on-site-manager/reducer';
import { patientNotesReducer } from './patient-notes/reducer';
import { patientFilesReducer } from './patient-files/reducer';
import { patientsReducer } from './patients/reducer';
import { persistReducer } from 'redux-persist';
import { providersReducer } from './providers/reducer';
import { schedulingReducer } from './scheduling/reducer';
import { serviceOfferingReducer } from './service-offering/reducer';
import storage from 'redux-persist/lib/storage';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { uiReducer } from './ui/reducer';
import { visitsReducer } from './visits/reducer';
import { marketMapReducer } from './market-map/reducer';
import { conciergeReducer } from './concierge/reducer';
import { RouterState } from 'redux-first-history';

declare const healConfig: any;

const uiPersistConfig = {
  key: `operations_ui_${healConfig.env || ''}`,
  storage,
  whitelist: ['expandNav', 'markets', 'onSiteManagerActiveItem', 'hubActiveItem', 'schedulingExpand', 'lastMapLocation', 'collapsibleSectionsClosed'],
};

export const rootReducer = (routerReducer: Reducer<RouterState>) => {
  return combineReducers<RootState>({
    router: routerReducer,
    toastr: toastrReducer,
    ui: persistReducer(uiPersistConfig, uiReducer),
    message: messageReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    visits: visitsReducer,
    createVisit: createVisitReducer,
    feeSchedule: feeScheduleReducer,
    markets: marketsReducer,
    claims: claimsReducer,
    claimDetails: claimDetailsReducer,
    patients: patientsReducer,
    patientNotes: patientNotesReducer,
    patientFiles: patientFilesReducer,
    concierge: conciergeReducer,
    providers: providersReducer,
    onSiteManager: onSiteManagerReducer,
    serviceOffering: serviceOfferingReducer,
    scheduling: schedulingReducer,
    marketMap: marketMapReducer,
  } as any);
};
